import SensorWidget from './SensorWidget'
import { WasteData, CO2Data, LightData, usePowerData, useLightData } from './Data'

export default SensorWidget
export { WasteData, CO2Data, LightData, usePowerData, useLightData }
